import { resendCustomerUserInvitationApi } from "@/api/services/main/customer-user";
import { TCustomerUserDetailDto } from "@/api/services/main/customer-user/dtos/customer-user.dto";
import { IconEdit, IconOutgoingMail } from "@/assets/icons";
import { DetailFooterShell } from "@/components/commons/DetailFooterShell";
import { Button } from "@/components/elements/Button";
import { useCurrentUserRole } from "@/features/auth/hooks/useCurrentUserRole";
import { canResendInvitation } from "@/features/customer-user/constant/statusHelpers";
import { AppRoutes, customerUserPath } from "@/routes/config";
import { USER_STATUS } from "@/types/enum";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { Stack } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

export const DetailFooter: FC<{ user: TCustomerUserDetailDto }> = ({ user }) => {
  const navigate = useNavigate();
  const { canMutateUsers } = useCurrentUserRole();
  const canResend = user.status !== USER_STATUS.DISABLED && canResendInvitation(user.accountStatus);

  const handleResend = async () => {
    try {
      await resendCustomerUserInvitationApi(user.id);
      toast.success("登録メールを再送信しました。");
    } catch (error) {
      showError(error);
    }
  };

  return (
    <DetailFooterShell>
      <Button variant="ghost" size="sm" onClick={() => navigate(AppRoutes.customerUsers)}>
        戻る
      </Button>
      {canMutateUsers && (
        <Stack direction="row" gap="12px">
          <Button
            variant="outline"
            size="sm"
            sx={{ minWidth: "102px" }}
            disabled={!canResend}
            onClick={handleResend}
            startIcon={<IconOutgoingMail />}
          >
            再招待
          </Button>
          <Button variant="primary" size="sm" sx={{ minWidth: "88px" }} onClick={() => navigate(customerUserPath.edit(user.id))} startIcon={<IconEdit />}>
            編集
          </Button>
        </Stack>
      )}
    </DetailFooterShell>
  );
};
